export default __webpack_public_path__ + "static/media/about.e0831336.png";